module.exports = __webpack_public_path__ + "client-static/img/logo_uin_label.bf5c6c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_uin_label.png
// module id = EpEO
// module chunks = 2